export default __webpack_public_path__ + "static/media/M.414d4d0f.png";